import { camelizeKeys } from 'humps';
import { prepareParams } from './prepareParams';
import type { GetBetsHistoryParams } from './types';

// todo zod schema
export const getBetsHistory: (
  args: GetBetsHistoryParams,
  send: (arg: unknown) => Promise<{ data: unknown }>
) => unknown = async (args, socketSend) => {
  const params = prepareParams(args);

  const result = await socketSend({
    cmd: 'bets_history/cardshistory',
    data: {
      params,
      filters: {
        extra: true
      }
    }
  });

  return camelizeKeys(result.data);
};
